import { render, staticRenderFns } from "./employeePanel.vue?vue&type=template&id=4fdd85cc&scoped=true"
import script from "./employeePanel.vue?vue&type=script&lang=js"
export * from "./employeePanel.vue?vue&type=script&lang=js"
import style0 from "./employeePanel.vue?vue&type=style&index=0&id=4fdd85cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdd85cc",
  null
  
)

export default component.exports